// eslint-disable-next-line no-shadow
export const KYCLevels = ['none', 'location', 'sdd', 'full'] as const
export type KYCLevel = (typeof KYCLevels)[number]
